export const joinNonEmpties = (strings, separator = ' ') => {
  const filtered = strings.filter(s => !!s).map(s => s.toString());
  if (filtered.length > 0) {
    return filtered && filtered.join(separator);
  }
  return undefined;
};
